import { CardMedia } from '@material-ui/core';

const ProductImage = ({ alt, className, image, title }) => <CardMedia component="img" alt={alt} className={className} image={image} title={title} />;

export default ProductImage;
